const settingsSections = {
    content: { key: 'settings', name: '{{lang}}settings', img: '/images/icons/layout.png' },
}

const settingsPages = {



    users: {
        key: 'users',
        title: 'مدیریت کاربران',
        description: 'لیست کاربران',
        fetchUrl: 'employeeGetAll',
        addUrl: 'employeeAdd',
        editUrl: 'employeeAdd',
        removeUrl: 'employeeRemove',
        // options: { noAddNew: true },
        // helperKey: 'values',
        pageType: 'form',
        postBody: { userType: 'employee' },
        parent: 'settings',
        options: {},
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            // unBlock: { key: "unBlock", label: '{{lang}}unblock', color: '#F87C56', function: "unBlockAdmin", permission: 'block' },
            // block: { key: "block", label: '{{lang}}block', color: '#ee5050', function: "blockAdmin", permission: 'block' },
            // terminateSessions: { key: "terminateSessions", label: '{{lang}}terminate sessions', color: '#ee5050', function: "terminateAdminSessions", permission: 'terminateSessions' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        // sort: { 'cDate': -1 },
        // addNew: -1,
        image: '/images/kheiry/usermng1.png',
        // extra: { export: { url: 'excelExport', name: 'export', function: 'openExport', icon: '/images/eye.svg' } },
        headers: [
            // { col: '6', key: 'number', type: 'TextInput', information: { label: '{{lang}}Code', disabled: true, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'username', type: 'TextInput', information: { label: '{{lang}}Username', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
            // { col: '6', key: 'phone', type: 'TextInput', information: { label: '{{lang}}Phone number', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'email', type: 'TextInput', information: { label: '{{lang}}Email', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'password', type: 'TextInput', information: { label: '{{lang}}Password', disabled: false }, showMain: false, inExport: true },
            // { type: 'MultiSelectInput', key: 'branches', col: '12', information: { label: 'دسترسی به شعب ', type: 'api', fields: { value: '_id', title: 'name' }, address: 'getApplets', filter: {} }, settings: { required: true }, showMain: true },
            { col: '6', key: 'userType', type: 'SelectInput', information: { label: '{{lang}}User Type', type: 'local', default: 'employee', items: [{ title: '{{lang}}Employee', value: 'employee' }], disabled: true }, showMain: false, inExport: true },

        ],

    },

    veterinarians: {
        key: 'veterinarians',
        title: '{{lang}}Veterinarians Management',
        description: '{{lang}}Veterinarians List',
        fetchUrl: 'employeeGetAll',
        addUrl: 'employeeAdd',
        editUrl: 'employeeAdd',
        removeUrl: 'employeeRemove',
        pageType: 'form',
        parent: 'settings',
        options: {},
        postBody: { userType: 'veterinarian' },
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#10453d', function: "openEditModal", permission: 'view' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        image: '/images/kheiry/Veterinarian.png',
        headers: [
            { col: '6', key: 'username', type: 'TextInput', information: { label: '{{lang}}Username', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'family', type: 'TextInput', information: { label: '{{lang}}family', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'nationalId', type: 'TextInput', information: { label: '{{lang}}National ID', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'values.birthDate', type: 'DateInput', information: { label: '{{lang}}Birth Date', disabled: false, required: false }, showMain: true, inExport: true },

            { col: '6', key: 'phone', type: 'PhoneInput', information: { label: '{{lang}}Phone Number', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'email', type: 'EmailInput', information: { label: '{{lang}}Email', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'password', type: 'PasswordInput', information: { label: '{{lang}}Password', disabled: false }, showMain: false, inExport: false },
            { col: '12', key: 'licenseNumber', type: 'TextInput', information: { label: '{{lang}}License Number', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '12', key: 'address', type: 'TextAreaInput', information: { label: '{{lang}}Address', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'userType', type: 'SelectInput', information: { label: '{{lang}}User Type', type: 'local', default: 'veterinarian', items: [{ title: '{{lang}}Veterinarian', value: 'veterinarian' }], disabled: true }, showMain: false, inExport: true },
        ],
    },

    horseBreeders: {
        key: 'horseBreeders',
        title: '{{lang}}Horse Breeders Management',
        description: '{{lang}}Horse Breeders List',
        fetchUrl: 'employeeGetAll',
        addUrl: 'employeeAdd',
        editUrl: 'employeeAdd',
        removeUrl: 'employeeRemove',
        pageType: 'form',
        parent: 'settings',
        options: {},
        postBody: { userType: 'horseBreeder' },
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#10453d', function: "openEditModal", permission: 'view' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },
        image: '/images/kheiry/horsebreeder.png',
        headers: [
            { col: '6', key: 'username', type: 'TextInput', information: { label: '{{lang}}Username', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'family', type: 'TextInput', information: { label: '{{lang}}Family', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'nationalId', type: 'TextInput', information: { label: '{{lang}}National ID', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'phone', type: 'PhoneInput', information: { label: '{{lang}}Phone Number', disabled: false, required: true }, showMain: true, inExport: true },
            { col: '6', key: 'email', type: 'EmailInput', information: { label: '{{lang}}Email', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'password', type: 'PasswordInput', information: { label: '{{lang}}Password', disabled: false }, showMain: false, inExport: false },
            { col: '12', key: 'stableName', type: 'TextInput', information: { label: '{{lang}}Stable Name', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'address', type: 'TextAreaInput', information: { label: '{{lang}}Address', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'userType', type: 'SelectInput', information: { label: '{{lang}}User Type', type: 'local', default: 'horseBreeder', items: [{ title: '{{lang}}Horse Breeder', value: 'horseBreeder' }], disabled: true }, showMain: false, inExport: true },
        ],
    },



    permissions: {
        key: 'permissions',
        title: 'دسترسی‌های مدیریتی',
        description: '{{lang}}Permissions List',
        fetchUrl: 'getPermissions',
        removeUrl: 'removePermission',
        // editUrl: 'addValue',
        // removeUrl: 'removeValue',
        pageType: 'form',
        page: 'permissions',
        parent: 'settings',
        image: '/images/kheiry/adminpermit1.png',
        addNew: '/settings/permission',
        hideFilter: true,
        headers: [
            // { key: 'groups', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}useful.groups', placeholder: '{{lang}}useful.groups', required: false, disabled: true }, showMain: true },
            { key: 'users', type: 'MultiSelectInput', col: '12', information: { label: '{{lang}}Users', fields: { title: 'username', value: '_id' }, placeholder: '{{lang}}useful.users', required: false, disabled: true, showAllInTable: true }, showMain: true },

            { key: 'description', type: 'TextInput', col: '12', information: { label: '{{lang}}Description', placeholder: '{{lang}}description', required: false, disabled: true }, showMain: true },


        ]
    },


    permission: {
        key: 'permission',
        title: 'permission',
        description: 'permission List',
        fetchUrl: 'getPermission',
        addUrl: 'addPermission',
        editUrl: 'addPermission',
        // removeUrl: 'removePermission',
        pageType: 'permissions',
        page: 'permissions',
        permissionRules: ['admin.permissions.create', 'admin.permissions.edit'],
        permissionParent: 'permissions',
        // parent: 'admin',
        hidePage: true,
        image: '/images/covers/dashboards.jpg',

        headers: [
            { type: 'TextInput', key: 'email', information: { label: 'Email', }, showMain: true },
            { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },
        ]
    },



    branches: {
        key: 'branches',
        title: 'مدیریت شعب',
        description: 'لیست شعب',
        fetchUrl: 'getApplets',
        addUrl: 'postApplet',
        editUrl: 'postApplet',
        removeUrl: 'removeApplet',

        pageType: 'form',
        // parent: 'settings',
        options: {},
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },

        image: '/images/kheiry/branch1.png',
        headers: [
            { col: '6', key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: true }, showMain: true, inExport: false },
            { col: '6', key: 'values.phone', type: 'TextInput', information: { label: '{{lang}}Phone number', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.city', type: 'TextInput', information: { label: '{{lang}}City', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.province', type: 'TextInput', information: { label: '{{lang}}Province', disabled: false, required: false }, showMain: true, inExport: true },
            { col: '12', key: 'values.address', type: 'TextAreaInput', information: { label: '{{lang}}Address', disabled: false, required: false }, showMain: true, inExport: true },

        ],

    },



    colors: {
        key: 'colors',
        title: ' رنگ ها',
        description: 'لیست رنگ',
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',

        pageType: 'form',
        parent: 'settings',
        options: {},
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },

            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },


        image: '/images/kheiry/colors1.png',
        headers: [
            { col: '6', key: 'values.enName', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.name', type: 'TextInput', information: { label: '{{lang}}Farsi Name', disabled: false, required: false }, showMain: true, inExport: false },


        ],

    },
    horses: {
        key: 'horses',
        title: 'مدیریت نژاد ها',
        description: 'لیست نژاد ها',
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        sort: { 'values.priority': -1 },
        pageType: 'form',
        parent: 'settings',
        options: {},
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },

            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },

        image: '/images/kheiry/race1.png',
        populates: [{ key: 'values.country', model: 'records', select: ['values.name'] }],

        headers: [
            { col: '6', key: 'values.name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.faName', type: 'TextInput', information: { label: '{{lang}}Farsi Name', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.momName', type: 'TextInput', information: { label: '{{lang}}mom Name', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.modelMaleMomDesc', type: 'TextInput', information: {  label: '{{lang}}Model Male Mom Description', disabled: false, required: false }, showMain: false, inExport: true },

            { col: '6', key: 'values.dadName', type: 'TextInput', information: { label: '{{lang}}dad Name', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.modelMaleDadDesc', type: 'TextInput', information: {  label: '{{lang}}Model Male Dad Description', disabled: false, required: false }, showMain: false, inExport: true },

            { col: '6', key: 'values.microChip', type: 'TextInput', information: { label: '{{lang}}Micro Chip Number', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.country', type: 'SelectInput', information: { label: '{{lang}}country', disabled: false, required: false, address: 'getRecords', filter: { filter: { frame: 'countries' } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.colour', type: 'SelectInput', information: { label: '{{lang}}Color', disabled: false, required: false, address: 'getRecords', filter: { filter: { frame: 'colors' } }, fields: { title: 'values.name', value: '_id' }, type: 'api', placeholder: '{{lang}}select', required: false }, showMain: true, inExport: true },
            { col: '6', key: 'values.birthDateMale', type: 'DateInputNew', information: { label: '{{lang}}Birth Date', disabled: false, required: false,onlyYear: true }, showMain: true, inExport: true },

            { col: '6', key: 'values.priority', type: 'TextInput', information: { label: '{{lang}}Priority', disabled: false, required: false }, showMain: true, inExport: false },


        ],

    },
    countries: {
        key: 'countries',
        title: 'مدیریت کشورها',
        description: 'لیست کشورها',
        fetchUrl: 'getRecords',
        addUrl: 'postRecord',
        editUrl: 'postRecord',
        removeUrl: 'removeRecord',
        sort: { 'values.priority': -1 },
        pageType: 'form',
        parent: 'settings',
        options: {},
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#F87C56', function: "openEditModal", permission: 'view' },

            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: "openRemoveModal", permission: 'delete' }
        },

        image: '/images/kheiry/country1.png',
        headers: [
            { col: '6', key: 'values.name', type: 'TextInput', information: { label: '{{lang}}Name', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.englishName', type: 'TextInput', information: { label: '{{lang}}English Name', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.iso2', type: 'TextInput', information: { label: '{{lang}}iso2', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.iso3', type: 'TextInput', information: { label: '{{lang}}iso3', disabled: false, required: false }, showMain: true, inExport: false },
            { col: '6', key: 'values.priority', type: 'TextInput', information: { label: '{{lang}}Priority', disabled: false, required: false }, showMain: true, inExport: false },


        ],

    },
    // AutoGens: {
    //     key: "AutoGens",
    //     title: 'AutoGens',
    //     description: 'AutoGens List',
    //     fetchUrl: 'getAutoGens',
    //     addUrl: 'addAutoGen',
    //     editUrl: 'addAutoGen',
    //     removeUrl: 'removeAutoGen',
    //     pageType: 'form',
    //     parent: 'settings',
    //     // addNew: -1,
    //     options: { noAddNew: true },

    //     image: '/images/covers/1.jpg',
    //     headers: [
    //         { type: 'TextInput', col: '6', key: 'format', information: { label: 'format', }, showMain: true },
    //         { type: 'TextInput', col: '6', key: 'app', information: { label: 'app', }, showMain: true },
    //         { type: 'TextInput', col: '6', key: 'resetNum', information: { label: 'resetNum', }, showMain: true },
    //         { type: 'TextInput', col: '6', key: 'key', information: { label: 'key ', }, showMain: true },

    //         // { type: 'TextInput', col: '6', key: 'email', information: { label: 'Email', }, showMain: false },
    //         // { type: 'PasswordInput', key: 'password', information: { label: 'Password', }, showMain: false },
    //         { type: 'DateInput', key: 'updateDate', col: '6', information: { label: 'update Date', time: false }, showMain: true },
    //         { key: 'number', type: 'NumberInput', col: '6', information: { label: 'Number', }, showMain: false, fullCol: true, inExport: true },

    //     ],
    // },

    settings: {
        key: 'settings',
        title: '{{lang}}settings',
        description: 'settings List',
        // fetchUrl: 'getSettings',

        // removeUrl: 'removePermission',
        pageType: 'settings',
        page: 'settings',

        parent: 'admin',
        hidePage: true,
        image: '/images/covers/dashboards.jpg',

        // headers: [
        //     { type: 'TextInput', key: 'email', information: { label: 'Email', }, showMain: true },
        //     { key: 'status', type: 'SelectInput', information: { label: 'Status', type: 'local', default: '0', items: [{ title: "unsubscribed", value: '0' }, { title: 'active', value: '1' }] }, settings: { required: false }, showMain: true },


        // ]
    },

    // adminLogs: {
    //     key: "adminLogs",
    //     title: '{{lang}}Admin Logs',
    //     description: '{{lang}}Admin Logs List',
    //     fetchUrl: 'getLogs',
    //     // addUrl: 'addEmployee',
    //     // editUrl: 'addEmployee',
    //     // removeUrl: 'removeEmployee',
    //     pageType: 'form',
    //     page: 'logs',
    //     parent: 'settings',
    //     postBody: {},

    //     addNew: -1,
    //     options: { noAddNew: true },
    //     actions: {
    //         edit: { key: "edit", label: '{{lang}}view', color: '#F87C56', function: "openEditModal", permission: 'view' },
    //     },
    //     // tabs: [
    //     //     { title: 'Admins', filter: { "role": 'admin' } },
    //     //     { title: 'Users', filter: { "role": 'user' } },

    //     // ],

    //     image: '/images/icons/log.png',
    //     headers: [
    //         { type: 'TextInput', key: 'name', information: { label: '{{lang}}Name', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'phone', information: { label: '{{lang}}Phone', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'committer', information: { label: '{{lang}}committed by', disabled: true }, showMain: true },
    //         { type: 'TextInput', key: 'ip', information: { label: '{{lang}}ip', disabled: true }, showMain: true },
    //         { type: 'TextAreaInput', key: 'message', information: { label: '{{lang}}Message', disabled: true }, showMain: true },
    //         { type: 'DateInput', key: 'cDate', information: { label: '{{lang}}Date/Time', time: true, disabled: true }, showMain: true },

    //         { type: 'TextInput', key: 'type', information: { label: '{{lang}}Type', disabled: true }, showMain: true },

    //     ],
    // },

}


export { settingsPages, settingsSections }